var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0E2933",
  d: "M12.667.667H3.333A3.337 3.337 0 0 0 0 4v8a3.337 3.337 0 0 0 3.333 3.333h9.334A3.337 3.337 0 0 0 16 12V4A3.337 3.337 0 0 0 12.667.667M3.333 2h9.334a2 2 0 0 1 1.853 1.258L9.415 8.364a2.005 2.005 0 0 1-2.83 0L1.48 3.258A2 2 0 0 1 3.333 2m9.334 12H3.333a2 2 0 0 1-2-2V5l4.31 4.307a3.34 3.34 0 0 0 4.714 0L14.667 5v7a2 2 0 0 1-2 2"
})));
export { SvgFiRrEnvelope as ReactComponent };
export default __webpack_public_path__ + "84fcdacd432fdd59e73e129bd99982dc.svg";